
import LogoffModal from './logoffModal.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    LogoffModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    function close() {
      emit('close')
      window.close()
    }

    function cancel() {
      emit('cancel')
      window.close()
    }

    function handleVerify() {
      emit('confirm')
    }

    return {
      props,
      close,
      handleVerify,
      cancel
    }
  }
})
